module.exports = __webpack_public_path__ + "img/S__90480702.fb0b8a26.jpg";